import { useCallback } from 'react';

//* HOC's
import { withLanguageContext } from 'context';

//* Components
import Image from 'components/common/Image';
import Text from 'components/common/Text';
import Icon from 'components/common/Icon';

//* Style
import ContentStyle from './style';

const Content = ({ image, text, publishedOn, translate, additional }) => {
	const handleDownload = useCallback(() => {
		const link = `${process.env.REACT_APP_API_SERVER}media/download-file/${additional.file.id}`;
		window.location.href = link;
	}, [additional]);

	return (
		<ContentStyle className='content'>
			<div className='content-image-block'>
				<Image
					src={image?.url}
					objectFit={'cover'}
					className={'content-image'}
					priority={true}
				/>
			</div>

			<div className='content-wrapper'>
				<div
					className='content'
					dangerouslySetInnerHTML={{ __html: text }}
				/>

				{additional?.file ? (
					<div className='additional'>
						{additional.title ? (
							<Text
								className={'p font-ping-bold'}
								text={additional.title}
							/>
						) : null}
						<a
							onClick={handleDownload}
							rel='noopener noreferrer'
							className='content-download-link'>
							<Text
								className={'pS font-ping-bolder'}
								text={'downloadFile'}
							/>
							<Icon
								name={'arrow-medium'}
								className={'download-btn-icon'}
							/>
						</a>
					</div>
				) : null}
				{publishedOn ? (
					<Text className={'p font-ping-bold published-on'}>
						<span className='font-ping-medium'>{translate('publishedOn')}</span> {publishedOn}
					</Text>
				) : null}
			</div>
		</ContentStyle>
	);
};

export default withLanguageContext(Content, ['translate']);
